var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [_vm._v("ยืนยันตัวตน")]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "form-horizontal" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "control-label h5" }, [
              _vm._v("ตัวอย่างรูป")
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-12" },
                [
                  _c("picture-input", {
                    ref: "pictureInput",
                    attrs: {
                      width: "400",
                      height: "400",
                      accept:
                        "image/jpeg,image/png,image/gif,image/svg,image/webp",
                      size: "5",
                      removable: true,
                      customStrings: {
                        upload: "<p>อัพโหลดเรียบร้อย</p>",
                        drag: "อัพโหลดรูป",
                        tap: "อัพโหลดรูป",
                        change: "เปลี่ยนรูป",
                        remove: "ลบรูป"
                      },
                      zIndex: 1000
                    },
                    on: { change: _vm.onChange }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-sm-12",
                  staticStyle: { "text-align": "center" }
                },
                [
                  _c("canvas", {
                    ref: "signaturePad",
                    staticClass: "canvas-box land-signature-pad"
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-4" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-info btn-lg btn-block",
                    on: {
                      click: function($event) {
                        return _vm.clearSignature()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fas fa-undo" }),
                    _vm._v(" เขียนลายเซ็นต์ใหม่")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: [
                      "btn btn-success btn-lg btn-block mt-2",
                      _vm._.isEmpty(this.signaturePad._data) || _vm.isSubmitting
                        ? "disabled"
                        : ""
                    ],
                    attrs: {
                      disabled:
                        _vm._.isEmpty(this.signaturePad._data) ||
                        _vm.isSubmitting
                    },
                    on: { click: _vm.submitContractSignature }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.isSubmitting ? "บันทึก..." : "บันทึก") +
                        "\n              "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("h4", { staticClass: "control-label h5" }, [
          _vm._v("ขั้นตอนการถ่ายรูปคู่บัตรเพื่อยืนยันตัวตน")
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-fluid pa-2",
          attrs: { src: "/static/img/professional/beneat_pdpa.jpg" }
        }),
        _c("br"),
        _vm._v(" "),
        _c(
          "ul",
          { staticStyle: { "list-style-type": "'-'", margin: "15px 20px" } },
          [
            _c("li", { staticClass: "control-label font-size-li" }, [
              _vm._v(" บัตรต้องไม่บังใบหน้าส่วนใดส่วนหนึ่ง")
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "control-label font-size-li" }, [
              _vm._v(" อย่าใส่หมวกหรือแว่นตาดำ")
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "control-label font-size-li" }, [
              _vm._v(" อย่าใส่ที่คาดผมหรือเครื่องประดับ")
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "control-label font-size-li" }, [
              _vm._v(" อย่าถ่ายครึ่งหน้า")
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "control-label font-size-li" }, [
              _vm._v(" รูปต้องชัดเจนให้เห็นอักษรบนบัตร")
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("label", { staticClass: "control-label h5" }, [
        _vm._v("รูปยืนยันตัวตน")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("label", { staticClass: "control-label col-sm-12 h5" }, [
        _vm._v("ลายเซ็นต์ยืนยันตัวตน")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3072ab49", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3072ab49","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/contract/ProfessionalContractIDCard.vue
// module id = 2074
// module chunks = 0